import { createAction, props } from '@ngrx/store';

export const checkEmailAvailability = createAction(
  '[Register] Check Email Availability',
  props<{ email: string }>()
);

export const checkEmailAvailabilitySuccess = createAction(
  '[Register] Check Email Availability Success',
  props<{ available: boolean }>()
);

export const checkEmailAvailabilityFailure = createAction(
  '[Register] Check Email Availability Failure',
  props<{ error: any }>()
);